import { Suspense, useMemo } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { resolveSportIds } from './consts';
import type { ResultsFilters, ResultsFormFilters } from './FilterTypes';
import { ResultsBreakdowns, ResultsBreakdownsContent } from './ResultsBreakdowns';
import ResultsTable, { ResultsTableContent } from './ResultsTable';

export function ResultsContents({
  baseUrl,
  userId,
  filters,
}: {
  baseUrl: string;
  form: UseFormReturn<ResultsFormFilters>;
  userId: API.Id | 'me' | 'archive';
  filters: ResultsFilters;
  breakdown?: string;
  title?: string;
}) {
  const { sportId: sportIdBase, startDate, endDate, playType, gameType, free } = filters;

  const sportId = useMemo(() => resolveSportIds(sportIdBase), [sportIdBase]);

  const serviceIds = useMemo(() => (sportIdBase === 'plus' ? [46, 59] : undefined), [sportIdBase]);

  return (
    <>
      <Suspense
        fallback={<ResultsBreakdownsContent baseUrl={baseUrl} userId={userId} filters={filters} />}
      >
        <ResultsBreakdowns baseUrl={baseUrl} userId={userId} filters={filters} />
      </Suspense>
      <Suspense fallback={<ResultsTableContent userId={userId} infiniteRequest={null} />}>
        <ResultsTable
          sportId={sportId}
          serviceIds={serviceIds}
          playType={playType}
          gameType={gameType}
          startDate={startDate}
          endDate={endDate}
          userId={userId}
          free={free}
        />
      </Suspense>
    </>
  );
}
